<template>
    <div class="moudle-title">
        <div class="line"></div>
        <p class="module-title-font">{{title}}</p>
    </div>
</template>
<script>
    export default {
        props:["title"]
    }
</script>
<style scoped>
    .moudle-title{
        display: flex;
        justify-content: flex-start;
    }
    .moudle-title .line{
        width: 6px;
        height: 26px;
        background: linear-gradient(to bottom,#F00F00,#FF9176,#FFDDD4);
        border-radius: 8px;
        margin-right: 8px;
    }
    .module-title-font{
        color: #333333;
        font-size: 32px;
        line-height: 32px;
        position: relative;
        top: -4px;
        font-family: pingFangSC-Medium;
    }
</style>